import React from "react";

const Perguntas = ({ perguntas }) => (
  <dl className="grid grid-cols-1 md:grid-cols-2 gap-10 xl:gap-16">
    {perguntas.map((item) => (
      <div key={item.p} className="border-t-2 border-pattern pt-6">
        <dt className="text-xl xl:text-2xl font-semibold mb-3">{item.p}</dt>
        <dd className="text-lg leading-relaxed text-gray-700">{item.r}</dd>
      </div>
    ))}
  </dl>
);

export default Perguntas;
